import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { BehaviorSubject, isObservable, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnChanges, OnDestroy {
  private _destroyed = new Subject();

  @Input() loading: Observable<boolean> | boolean;
  @Input() small = false;

  loader = new BehaviorSubject(false);

  ngOnChanges(): void {
    if (isObservable(this.loading)) {
      this.loading
        .pipe(
          takeUntil(this._destroyed),
          map((loading) => {
            this.loader.next(loading);
          })
        )
        .subscribe();
    } else {
      this.loader.next(this.loading);
    }
  }

  ngOnDestroy(): void {
    this._destroyed.next(true);
    this._destroyed.complete();
  }
}
